import { ColumnDef } from "@tanstack/react-table";
import { Link } from "@heroui/link";
import type { TFunction } from "i18next";

import { getAuditColumns } from "@/features/Audit/getAuditColumns";

export type A7OPCVMStrategy = {
  id: string;
  name: string;
  code: string;
  manager_name: string;
  manager_contact: string;
  business_manager: string;
};

const tableName = "a7_opcvm_strategies";

export const getStrategiesColumns = (
  t: TFunction,
): ColumnDef<A7OPCVMStrategy>[] => {
  const tTable = (key: string, defaultValue: string) =>
    t(`${tableName}.columns.${key}`, { ns: "tables", defaultValue });
  const tCommon = (key: string, defaultValue: string) =>
    t(`actions.${key}`, { ns: "common", defaultValue });

  return [
    {
      accessorKey: "id",
      header: tTable("id", "ID"),
    },
    {
      accessorKey: "identifiant_fonds",
      header: tTable("identifiant_fonds", "Fund identifier"),
    },
    {
      accessorKey: "devise_de_reporting",
      header: tTable("devise_de_reporting", "Reporting currency"),
    },
    {
      accessorKey: "denomination_fonds",
      header: tTable("denomination_fonds", "Fund name"),
    },
    {
      accessorKey: "contact_fonds",
      header: tTable("contact_fonds", "Fund contact"),
    },
    {
      accessorKey: "contact_afd",
      header: tTable("contact_afd", "AFD contact"),
    },
    {
      id: "actions",
      cell: ({ row }) => {
        return (
          <div className="flex justify-end">
            <Link
              href={`${window.location.pathname}/${row.getValue("id")}`}
              className="text-xs"
              underline="hover"
            >
              {tCommon("edit", "Edit")}
            </Link>
          </div>
        );
      },
    },
  ];
};

export const getStrategiesAuditColumns = (t: TFunction) =>
  getAuditColumns<A7OPCVMStrategy>(getStrategiesColumns(t));
